export default {
  googleAuthorizeTerms: "This app will not be supported after 10th Mar 2023. Please install our new version of {googleAppName}."
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
